import { useState, useEffect } from "react";
import {
  VStack,
  Flex,
  Box,
  Text,
  NumberInput,
  NumberInputField,
  useColorModeValue,
  Button,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { CustomPopover } from "../custom-popover";
import { TEXT_COLOR_LIGHT, TEXT_COLOR_DARK, baseFilterValues } from "../utils";

interface Props {
  value: [string, string];
  onApply: (newValue: [string, string]) => void;
}

export function CompanySizeFilter({ value, onApply }: Props) {
  const [minFollowers, setMinFollowers] = useState<string>("");
  const [maxFollowers, setMaxFollowers] = useState<string>("");
  const textColor = useColorModeValue(TEXT_COLOR_LIGHT, TEXT_COLOR_DARK);

  useEffect(() => {
    setMinFollowers(value[0]);
    setMaxFollowers(value[1]);
  }, [value]);

  let isActive = false;
  if (
    value[0] !== baseFilterValues.followers[0] ||
    value[1] !== baseFilterValues.followers[1]
  ) {
    isActive = true;
  }

  return (
    <CustomPopover
      property="No. of employees"
      value={`${value[0] || 0}-${value[1] || "unlimited"}`}
      isActive={isActive}
    >
      <VStack color={textColor} alignItems="flex-start" py="2">
        <Flex>
          <Box mr="2">
            <InfoOutlineIcon />
          </Box>
          <Box>
            <Text fontSize="xs">
              Number of employees in their current company.
            </Text>
          </Box>
        </Flex>
        <NumberInput
          size="sm"
          pt="2"
          value={minFollowers}
          onChange={(value) => setMinFollowers(value)}
        >
          <NumberInputField
            placeholder="Min. (default 0)"
            borderRadius="md"
            _placeholder={{ color: textColor }}
            color="initial"
          />
        </NumberInput>
        <NumberInput
          size="sm"
          value={maxFollowers}
          onChange={(value) => setMaxFollowers(value)}
        >
          <NumberInputField
            placeholder="Max. (default unlimited)"
            borderRadius="md"
            _placeholder={{ color: textColor }}
            color="initial"
          />
        </NumberInput>
        <Box pt="2" pl="1">
          <Button
            variant="primary"
            size="sm"
            onClick={() => onApply([minFollowers, maxFollowers])}
          >
            Apply
          </Button>
        </Box>
      </VStack>
    </CustomPopover>
  );
}
